module.exports = __webpack_public_path__ + "static/img/success.45649e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/success.png
// module id = 4AGf
// module chunks = 29